import React from "react";
import TaskView from "./TaskView";
import WorkerInfo from "./WorkerInfo";

function TaskQueueView(props) {
  return (
    <React.Fragment>
      <div className="row">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#Download"
              type="button"
              role="tab"
              aria-controls="Download"
              aria-selected="true"
            >
              <strong>Task Info</strong>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#upload"
              type="button"
              role="tab"
              aria-controls="upload"
              aria-selected="false"
            >
              <strong>Worker Info</strong>
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="Download"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <TaskView />
          </div>
          <div
            className="tab-pane fade"
            id="upload"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div>
              <WorkerInfo />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default TaskQueueView;
